import { SVG } from '../svg';
import { IconProps } from '../types';

export function TargetIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="6" />
      <circle cx="12" cy="12" r="2" />
    </SVG>
  );
}
